import { render, staticRenderFns } from "./BlockListView.vue?vue&type=template&id=05a17712&scoped=true&"
import script from "./BlockListView.vue?vue&type=script&lang=js&"
export * from "./BlockListView.vue?vue&type=script&lang=js&"
import style0 from "./BlockListView.vue?vue&type=style&index=0&id=05a17712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a17712",
  null
  
)

export default component.exports